export const apiHost = process.env.REACT_APP_API_ENDPOINT;
export const medaiHost = process.env.REACT_APP_MEDIA_API_ENDPOINT;
export const fileUploadApiUrl = () => `${ apiHost }/fileUpload`;
export const apiUrl = process.env.REACT_APP_API_URL;
export const SESSION_EXPIRED = 'Your session has expired. Please try to login again';
export const UN_AUTHORIZED = 'Error: Unauthorized';
export const ABORT_ERROR = 'AbortError: The user aborted a request.';
export const ADMIN_USER = '123456789';
export const SUPER_ADMIN = 'superadmin';
export const FILE_TYPE = {
    IMAGE: 'image',
    PROFILE: 'profile'
}
export const AUTO_LOGOUT_TIME = 60 * 60 * 1000; // 1 hour timeout
// export const AUTO_LOGOUT_TIME = 5 * 60 * 1000; // 5 minutes timeout
export const AUTO_LOGOUT_MESSAGE = 'You have been logged out since you were idle for a while.. Please login again to continue.'
export const REACT_APP_GOOGLE_LOCATION_API_KEY = process.env.REACT_APP_GOOGLE_LOCATION_API_KEY
